import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiTattooGeneratorConfig } from '@/data/landingConfig/landingAiTattooGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiTattooGenerator } from './schemaObject';

interface Props {}
const AiTattooGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiTattooGenerator} />
			<LandingTemplate
				data={landingAiTattooGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTattooGenerator()}
			/>
		</>
	);
};

export default AiTattooGenerator;
